const Vision = () => {
  return (
    <section
      id="vision"
      data-testid="vision-section"
      className="relative py-32 md:py-44 border-t border-white/[0.06] overflow-hidden"
    >
      {/* ambient glow */}
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
        <div className="absolute left-1/2 top-0 -translate-x-1/2 h-[600px] w-[900px] rounded-full bg-indigo-600/10 blur-[140px]" />
        <div className="absolute left-1/3 bottom-0 h-[400px] w-[500px] rounded-full bg-violet-600/10 blur-[120px]" />
      </div>

      <div className="relative max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.03] px-3 py-1">
          <span className="h-1.5 w-1.5 rounded-full bg-violet-400 shadow-[0_0_10px_rgba(139,92,246,0.9)]" />
          <span className="font-mono uppercase tracking-[0.2em] text-[10.5px] text-zinc-400">
            The Vision
          </span>
        </div>

        <h2 className="mt-8 font-display font-semibold tracking-tighter text-balance text-white text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
          A universal interaction layer{" "}
          <span className="text-zinc-500">for the internet.</span>
        </h2>

        <p className="mt-8 font-body text-zinc-300 text-lg md:text-xl leading-relaxed max-w-2xl mx-auto text-balance">
          Equal is building a universal interaction layer for the internet — where users no longer adapt to
          interfaces, but interfaces adapt to <em className="not-italic text-white">them</em>.
        </p>

        <div className="mt-14 grid md:grid-cols-3 gap-4 text-left">
          {[
            {
              k: "Beyond assistive tech",
              v: "Not a plugin for a niche — an interaction standard for everyone.",
            },
            {
              k: "Beyond one platform",
              v: "Works across websites, apps, and devices — wherever people already are.",
            },
            {
              k: "Beyond point-and-click",
              v: "Intent becomes the interface. The rest is quietly handled.",
            },
          ].map((item, i) => (
            <div
              key={i}
              className="rounded-xl border border-white/[0.06] bg-white/[0.015] p-6"
              data-testid={`vision-card-${i}`}
            >
              <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-indigo-300">
                Principle / 0{i + 1}
              </div>
              <div className="mt-3 font-display text-white text-lg tracking-tight">{item.k}</div>
              <p className="mt-2 font-body text-[14.5px] leading-relaxed text-zinc-400">{item.v}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Vision;
